import improvedecision from "@/src/improvedecision";
import Client from "@/modules/internal_api/client";
import { rbgRateGoodV100, rbgRateBadV100 } from "kaleido-event-tracker";
import { Image, ProcessingState } from "@/modules/internal_api/image";
import { useEditorStore } from "@/stores/editor_store";
import { FlashAlertsManager } from "@/modules/flash_alerts";
import { inject, onMounted, ref } from "vue";

export const useImageReporter = () => {
  const store = useEditorStore();
  const I18n = inject("I18n", window.I18n);
  const consented = ref(undefined);

  const updateConsentedValue = () => {
    const decision = improvedecision.get();

    if (decision === undefined) {
      consented.value = undefined;
    } else if (decision === "accept") {
      consented.value = true;
    } else if (decision === "reject") {
      consented.value = false;
    }
  };

  onMounted(() => {
    updateConsentedValue();
  });

  const saveConsentedDecision = (decision: boolean) => {
    improvedecision.set(decision ? "accept" : "reject");
    consented.value = decision;
  };

  const needsDialog = (): boolean => {
    const decision = improvedecision.get();
    return decision !== "accept";
  };

  const ratePositive = (image: Image) => {
    window.track("Images", "rate_good", "Rate good");
    rbgRateGoodV100({ image_id: image.meta.id });
    rate(1, image);
  };

  const rateNegative = (image: Image) => {
    window.track("Images", "rate_bad", "Rate bad");
    rbgRateBadV100({ image_id: image.meta.id });
    rate(-1, image);
  };

  const rate = (newRating: number, image: Image) => {
    if (consented.value === undefined) {
      updateConsentedValue();
    }

    consented.value ??= false;
    Client.rateImage(image, newRating, consented.value);

    if (image.previewResult.state == ProcessingState.Finished) {
      image.previewResult.rated = true;
      image.previewResult.rating = newRating;
      store.updateImage(image);
    }

    const flashMessage = consented.value
      ? I18n.t("improve.thank_you_for_image_submit")
      : I18n.t("improve.thanks_for_being_honest");

    const flashAlertsManager = new FlashAlertsManager(store.flashAlerts);
    flashAlertsManager.create(flashMessage, "positive", 3000);
  };
  return {
    updateConsentedValue,
    saveConsentedDecision,
    needsDialog,
    rateNegative,
    ratePositive,
    consented,
  };
};
